import {
  GRID_CHECKBOX_SELECTION_FIELD,
  GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
  GRID_TREE_DATA_GROUPING_FIELD,
} from '@mui/x-data-grid-premium';

export {
  DEFAULT_STATUS_COLORS,
  BOOLEAN_STATUS_COLORS,
  type StatusColorConfig,
} from '@/shared/ui/cells/statusColors';

// Grid-managed columns (row-selection checkbox, groupBy grouping column, tree-data
// grouping column). Skipped when resolving the "first real data column" for
// row-click targeting and when computing the persisted column config.
export const SYSTEM_COLUMN_FIELDS = new Set([
  GRID_CHECKBOX_SELECTION_FIELD,
  GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
  GRID_TREE_DATA_GROUPING_FIELD,
]);

// Tree depth is what tells a child row apart from its parent, so every level shifts the
// chevron and the first data column right by the same step — they must move together or the
// chevron drifts away from the text it belongs to.
export const TREE_INDENT_STEP_REM = 1;
// Deeper rows keep the indent of this level; the class set backing it has to be finite.
export const MAX_TREE_INDENT_DEPTH = 6;

export const TOOLBAR_SEARCH_INPUT_WIDTH = 200;
export const TOOLBAR_BUTTON_EXPANDED_WIDTH = 80;
export const TOOLBAR_BUTTON_COLLAPSED_WIDTH = 30;
// Used to estimate action button width from label character count:
// 7px avg char width at 12px font + 24px padding + 18px icon+gap
export const TOOLBAR_BUTTON_CHAR_WIDTH = 7;
export const TOOLBAR_BUTTON_BASE_WIDTH = 42;
export const TOOLBAR_DROPDOWN_EXPANDED_WIDTH = 125;
export const TOOLBAR_DROPDOWN_COLLAPSED_WIDTH = 29;
export const TOOLBAR_ICON_BUTTON_WIDTH = 29;
export const TOOLBAR_VIEW_TOGGLE_WIDTH = 60;
export const TOOLBAR_VARIANT_TOGGLE_WIDTH = 120;
export const TOOLBAR_PRIMARY_BUTTON_WIDTH = 145;
export const TOOLBAR_GAP = 4;
export const TOOLBAR_SECTION_GAP = 24;
export const TOOLBAR_PADDING = 14;

// Filter field id for the campaign period date-range filter. Sort/group/column
// options disabled by campaignColumnVisibility open this field's calendar on click.
export const CAMPAIGN_PERIOD_FIELD_ID = 'dateRange';

export const PAGINATION_HEIGHT = 49;

// Normal column buffer: render only the visible columns (+ a small margin) so
// rows stay cheap to mount and fast-scrolling doesn't flash blank rows.
export const DEFAULT_COLUMN_BUFFER_PX = 150;

// Wider than any realistic table — used ONLY while a column is being dragged, so
// the custom drag-and-drop (useDraggedColumnHighlight) has every column header/
// cell in the DOM to resolve drop targets and highlight the dragged column.
// Outside of a drag we fall back to DEFAULT_COLUMN_BUFFER_PX.
export const ALL_COLUMNS_BUFFER_PX = 100_000;

// Overscan: render extra rows above/below the viewport so their (image-heavy)
// cells start loading before they scroll into view, keeping scrolling smooth
// without giving up row virtualization. ~1500px ≈ a couple of extra screens.
export const ROW_OVERSCAN_PX = 1_500;

export const CHECKBOX_HIDDEN_ROW_CLASS = 'GeneratikTable-checkboxHiddenRow';
